import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { useTranslation } from 'react-i18next';
import {textFieldSx} from '../../lib/constants';
import SubmitButton from '../common/SubmitButton';


function LoginFormForm(props) {
  const { t } = useTranslation();
  const { username, password, isSubmitting, step, setUsername, setPassword, onEmailSubmit, onFormSubmit, onBack } = props;

  function handleUsernameChange(event) {
    const newValue = event.target.value || '';
    setUsername(newValue);
  }

  function handlePasswordChange(event) {
    const newValue = event.target.value || '';
    setPassword(newValue);
  }

  if (step === 'email') {
    return (
      <ValidatorForm
        data-testid="login-form-email"
        onSubmit={ onEmailSubmit }
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
          <TextValidator
            sx={ textFieldSx }
            id="LoginForm-email"
            label={t('auth.common.fields.email')}
            variant="filled"
            value={ username }
            onChange={ handleUsernameChange }
            validators={['required']}
            errorMessages={[t('auth.common.required.email')]}
          />
          <SubmitButton isSubmitting={ isSubmitting }>
            {t('auth.login.next')}
          </SubmitButton>
        </Box>
      </ValidatorForm>
    );
  }

  return (
    <ValidatorForm
      data-testid="login-form"
      onSubmit={ onFormSubmit }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <TextField
          sx={ textFieldSx }
          id="LoginForm-email-readonly"
          label={t('auth.common.fields.email')}
          variant="filled"
          value={ username }
          disabled
        />
        <TextValidator
          sx={ textFieldSx }
          id="LoginForm-password"
          type="password"
          label={t('auth.common.fields.password')}
          variant="filled"
          value={ password }
          onChange={ handlePasswordChange }
          validators={['required']}
          errorMessages={[t('auth.common.required.password')]}
        />
        <SubmitButton isSubmitting={ isSubmitting }>
          {t('auth.login.logIn')}
        </SubmitButton>
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={ onBack }
          sx={{ mt: 1 }}
        >
          {t('auth.login.back')}
        </Link>
      </Box>
    </ValidatorForm>
  );
}

export default LoginFormForm;
